import {useMemo} from "react";

export function createRef_withHooks<T>(opt: {postSet: (val: T)=>void}) {
	const ref = {
		_current: null as T,
		get current() {
			return ref._current;
		},
		set current(val: T) {
			ref._current = val;
			opt.postSet(val);
		},
	};
	return ref;
}

/*export function usePropsStable<T extends {}>(props_latest: T): T {
	const props = useMemo(()=>props_latest, []);
	Object.getOwnPropertyNames(props).forEach(key=>delete props[key]);
	Object.assign(props, props_latest);
	return props;
}*/